/**
 * The task a side chat was opened FOR from the sticky bar (`lib/sticky-chat-tap.ts`), carried to the
 * first send in that conversation as `references.taskId` — the reference the inline composer's handoff
 * attaches, which stops the agent opening a second task for the card the user is on.
 *
 * One-shot and keyed by conversation: only a send in the conversation it was armed for takes it.
 */
let armed: { conversationId: string | null; taskId: string } | null = null;

export function armSideChatTaskReference(conversationId: string | null, taskId: string): void {
  armed = { conversationId, taskId };
}

export function takeSideChatTaskReference(conversationId: string | null | undefined): string | undefined {
  if (!armed || (armed.conversationId ?? null) !== (conversationId || null)) return undefined;
  const { taskId } = armed;
  armed = null;
  return taskId;
}
